var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, CheckboxGroup } from 'shared/components/ui';
import { Controller, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { useFieldContext } from 'shared/components';
export var FormCheckboxGroup = function (_a) {
    var labelMap = _a.labelMap, name = _a.name, invalidateOnError = _a.invalidateOnError, errors = _a.errors;
    var _b = useFormContext(), control = _b.control, getValues = _b.getValues;
    var readOnly = useFieldContext().readOnly;
    var errorMessages = get(errors, name);
    var hasError = !!errors && errorMessages;
    var defaultValue = getValues(name) || [];
    return (_jsx(Controller, { control: control, name: name, defaultValue: defaultValue, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref, error = _a.fieldState.error;
            return (_jsx(CheckboxGroup, __assign({ defaultValue: defaultValue, value: value, onChange: onChange }, { children: Object.entries(labelMap).map(function (_a) {
                    var cbEnum = _a[0], label = _a[1];
                    return (_jsx(Checkbox, __assign({ "data-testid": "".concat(name, "-").concat(cbEnum), name: name, mr: 2, mb: 2, value: cbEnum, readOnly: readOnly }, (invalidateOnError && hasError && { isInvalid: true }), { children: label }), cbEnum));
                }) })));
        } }));
};
